const isServerSide = typeof window === "undefined";
const serverSideWarn = () => {
    console.warn("This is a server-side version of the @guardian/consent-management-platform", "No consent signals will be received.");
};
const serverSideWarnAndReturn = (arg) => {
    return () => {
        serverSideWarn();
        return arg;
    };
};
const cmp = {
    __disable: serverSideWarn,
    __enable: serverSideWarnAndReturn(false),
    __isDisabled: serverSideWarnAndReturn(false),
    hasInitialised: serverSideWarnAndReturn(false),
    init: serverSideWarn,
    showPrivacyManager: serverSideWarn,
    version: "n/a",
    willShowPrivacyMessage: serverSideWarnAndReturn(Promise.resolve(false)),
    willShowPrivacyMessageSync: serverSideWarnAndReturn(false)
};
const onConsent = () => {
    serverSideWarn();
    return Promise.resolve({
        canTarget: false,
        framework: null
    });
};
const onConsentChange = () => {
    return serverSideWarn();
};
const getConsentFor = (vendor, consent) => {
    console.log(`Server-side call for getConsentFor(${vendor}, ${JSON.stringify(consent)})`, "getConsentFor will always return false server-side");
    serverSideWarn();
    return false;
};
export { cmp, getConsentFor, isServerSide, onConsent, onConsentChange, serverSideWarn, serverSideWarnAndReturn };
